<template>
  <div>
    <div>
      <el-button class="el-button--query handel-btn" size="mini" round @click="handelChoose">
        选择红人
      </el-button>
    </div>
    <el-dialog title="选择红人" :visible.sync="show" width="800px" append-to-body
               class="drawer-choose-artist-container">
      <div v-loading="loading" class="item-dialog-content default-table">
        <div class="item-selection-container">
          <!-- 左侧：明细列表 -->
          <div class="item-list-container">
            <div class="search-box">
              <el-form inline :model="search" class="demo-form-inline">
                <el-form-item>
                  <el-input v-model="search.nickname" placeholder="搜索红人昵称" clearable
                            @keyup.enter.native="onSearch"/>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSearch">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
            <el-table ref="table" :data="table" height="460" size="mini"
                      @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" :selectable="selectable"/>
              <el-table-column prop="nickname" label="红人昵称" show-overflow-tooltip/>
              <el-table-column prop="agent_name" label="经纪人" show-overflow-tooltip/>
            </el-table>
            <pagination :total.sync="search.total" :limit.sync="search.per_page" :page.sync="search.page"
                        @pagination="getTableData" layout="total, prev, pager, next"/>
          </div>

          <!-- 右侧：已选明细 -->
          <div class="selected-itets-container">
            <div class="selected-title">已选红人 ({{ selectedItemsTemp.length }})</div>
            <div class="selected-list">
              <div v-for="(item, index) in selectedItemsTemp" :key="item.key" class="selected-item">
                <div class="selected-item-info">
                  <div class="selected-item-name">
                    {{ item.nickname || '' }}
                  </div>
                </div>
                <el-button
                    type="text"
                    icon="el-icon-close"
                    class="remove-btn"
                    @click="removeSelectedItem(index)"
                />
              </div>
              <div v-if="selectedItemsTemp.length === 0" class="empty-selected">
                暂无已选明细
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" @click="confirmSelection">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {getFBoyList} from "@/api/fboy";

let by_hand = false
export default {
  name: 'DiaChooseArtists',
  props: {
    collection: {
      type: [Array, Object, Boolean],
      default() {
        return []
      }
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      table: [],
      selectedKeys: new Set(),
      selectedItemsTemp: [],
      search: {
        page: 1,
        per_page: 10,
        total: 0,
        material_name: null,
        material_no: null
      }
    }
  },
  created() {
  },
  methods: {
    onSearch() {
      this.search.page = 1
      this.getTableData()
    },
    async getTableData() {
      by_hand = true
      this.loading = true
      const {model: {data: {data: table, total}}} = await getFBoyList(this.search)
      this.loading = false
      table.map(_ => {
        _.key = _.nickname
      })
      this.table = table
      this.search.total = total
      this.setTableSelection()
      by_hand = false
    },
    // 设置表格选中状态
    setTableSelection() {
      if (!this.$refs.table || this.table.length === 0) {
        return
      }

      // 使用双重$nextTick确保表格完全渲染
      this.$nextTick(() => {
        const selectedItemNos = new Set(this.selectedItemsTemp.map(item => item.key))
        // 先清除所有选中
        this.$refs.table.clearSelection()
        // 然后设置当前页的选中状态
        this.table.forEach(row => {
          if (selectedItemNos.has(row.key)) {
            this.$refs.table.toggleRowSelection(row, true)
          }
        })
      })
    },
    async handelChoose() {
      this.selectedKeys = new Set()
      this.selectedItemsTemp = []
      this.show = true
      await this.getTableData()
    },
    selectable() {
      return true
    },
    // 弹窗关闭处理
    handleDialogClose() {
      this.show = false
      this.search.nickname = null
    },
    /**
     * 确认选择，关闭弹窗并触发事件回调
     */
    confirmSelection: function () {
      this.$emit('sure', this.selectedItemsTemp.map(item => item.nickname))
      this.show = false
    },
    // 表格选择变化
    handleSelectionChange(selection) {
      if (by_hand) {
        by_hand = false
        return
      }

      // 获取当前页选中的明细编号，过滤明细编号
      const currentPageSelectedNos = new Set(
          selection
              .map(item => item.key)
              .filter(key => key != null && key !== '')
      )

      // 获取当前页所有明细编号，过滤明细编号
      const currentPageAllNos = new Set(
          this.table
              .map(item => item.key)
              .filter(key => key != null && key !== '')
      )

      // 更新选中ID集合
      // 只处理当前页的数据，不影响其他页的选中状态
      currentPageAllNos.forEach(itemKey => {
        if (currentPageSelectedNos.has(itemKey)) {
          // 当前页选中的，添加到集合
          this.selectedKeys.add(itemKey)
        } else {
          // 当前页未选中的，从集合中移除（但只移除当前页的数据）
          // 注意：这里需要确保这个key确实在当前页的数据中
          // 因为selectedKeys可能包含其他页的选中key
          if (currentPageAllNos.has(itemKey)) {
            this.selectedKeys.delete(itemKey)
          }
        }
      })
      // 更新临时选中列表
      this.updateSelectedItemsTemp()
    },

    // 更新临时选中列表
    updateSelectedItemsTemp() {
      // 创建一个Map来存储所有选中的明细，用于快速查找
      const itemMap = new Map()

      // 首先，从当前页的table中添加选中的明细
      this.table.forEach(row => {
        if (this.selectedKeys.has(row.key)) {
          itemMap.set(row.key, {...row})
        }
      })

      // 然后，我们需要保持原始selectedItemsTemp的顺序
      // 创建一个新的数组来保持顺序
      const newSelectedItemsTemp = []

      // 首先添加旧的selectedItemsTemp中仍然被选中的项目，保持原有顺序
      this.selectedItemsTemp.forEach(item => {
        if (this.selectedKeys.has(item.key)) {
          // 如果这个项目在当前页的数据中有更新，使用更新的数据
          if (itemMap.has(item.key)) {
            newSelectedItemsTemp.push(itemMap.get(item.key))
            itemMap.delete(item.key) // 从map中移除，避免重复添加
          } else {
            // 否则使用旧的数据
            newSelectedItemsTemp.push({...item})
          }
        }
      })

      // 最后，添加新选中的项目（不在旧列表中的）
      // 这些新项目按照它们在table中出现的顺序添加
      this.table.forEach(row => {
        if (itemMap.has(row.key)) {
          newSelectedItemsTemp.push(itemMap.get(row.key))
        }
      })

      // 更新临时选中列表
      this.selectedItemsTemp = newSelectedItemsTemp
    },
    // 移除已选明细
    removeSelectedItem(index) {
      const item = this.selectedItemsTemp[index]
      if (item && item.key) {
        this.selectedKeys.delete(item.key)
        this.selectedItemsTemp.splice(index, 1)

        // 更新表格选中状态
        this.$nextTick(() => {
          if (this.$refs.itemTable) {
            this.table.forEach(row => {
              if (row.key === item.key) {
                this.$refs.table.toggleRowSelection(row, false)
              }
            })
          }
        })
      }
    },
  }
}
</script>
<style lang="scss">
.drawer-choose-artist-container {
  // 弹窗样式
  .item-dialog-content {
    .item-selection-container {
      display: flex;
      height: 500px;
      gap: 20px;

      .item-list-container {
        width: 300px;
        flex: 2;
        display: flex;
        flex-direction: column;

        .search-box {
          margin-bottom: 15px;

          .el-input {
            width: 100%;
          }
        }

        .pagination-container {
          margin-top: 15px;
          display: flex;
          justify-content: flex-end;
        }
      }

      .selected-itets-container {
        flex: 1;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        display: flex;
        flex-direction: column;

        .selected-title {
          padding: 12px 16px;
          background-color: #f5f7fa;
          border-bottom: 1px solid #e4e7ed;
          font-weight: 600;
          color: #303133;
        }

        .selected-list {
          flex: 1;
          overflow-y: auto;
          padding: 10px;

          .selected-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 8px 10px;
            margin-bottom: 8px;
            background-color: #FFF9FBFC;
            border: 1px solid #f56c6c;
            border-radius: 4px;

            .selected-item-info {
              flex: 1;

              .selected-item-name {
                font-weight: 500;
                color: #303133;
                margin-bottom: 2px;
              }

              .selected-item-no {
                font-size: 12px;
                color: #909399;
              }
            }

            .remove-btn {
              padding: 0;
              margin-left: 8px;
              color: #f56c6c;

              &:hover {
                color: #f78989;
              }
            }
          }

          .empty-selected {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            color: #909399;
            font-size: 14px;
          }
        }
      }
    }
  }

}
</style>
